import TheAscender from './basteleurcards-01-the-ascender.svg'
import TheBold from './basteleurcards-02-the-bold.svg'
import TheCedilla from './basteleurcards-03-the-cedilla.svg'
import TheDescender from './basteleurcards-04-the-descender.svg'
import TheEmdash from './basteleurcards-05-the-emdash.svg'
import TheFont from './basteleurcards-06-the-font.svg'
import TheGlyph from './basteleurcards-07-the-glyph.svg'
import TheHinting from './basteleurcards-08-the-hinting.svg'
import TheItalic from './basteleurcards-09-the-italic.svg'
import Justify from './basteleurcards-10-justify.svg'
import TheKerning from './basteleurcards-11-the-kerning.svg'
import TheLowercase from './basteleurcards-12-the-lowercase.svg'
import TheMasters from './basteleurcards-13-the-masters.svg'
import TheNewfont from './basteleurcards-14-the-newfont.svg'
import TheOpentype from './basteleurcards-15-the-opentype.svg'
import ThePoint from './basteleurcards-16-the-point.svg'
import TheQuotemark from './basteleurcards-17-the-quotemark.svg'
import TheRevival from './basteleurcards-18-the-revival.svg'
import TheSans from './basteleurcards-19-the-sans.svg'
import TheTypeDesigner from './basteleurcards-20-the-type-designer.svg'
import TheUppercase from './basteleurcards-21-the-uppercase.svg'
import TheOtherOnes from './basteleurcards-22-the-other-ones.svg'
import Verso from './basteleurcards-verso.svg'

export default {
    TheAscender, TheBold, TheCedilla, TheDescender, TheEmdash, TheFont, TheGlyph,
    TheHinting, TheItalic, Justify, TheKerning, TheLowercase, TheMasters, TheNewfont,
    TheOpentype, ThePoint, TheQuotemark, TheRevival, TheSans, TheTypeDesigner, TheUppercase,
    TheOtherOnes, Verso
}
